export default __webpack_public_path__ + "static/media/close.90e71998.svg";